/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config";

const PricingBanner = () => {
  return (
    <motion.div
      variants={animation}
      className="bg-pricingBlue shadow-inner pt-5 xl:pt-14 lg:pt-14 rounded-b-3xl overflow-hidden"
    >
      <div className="container mx-auto">
        {/* TEXT AND TESTIMONIALS */}
        <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 pb-5 xl:pb-20 lg:pb-20 items-center">
          <div className="col-span-1">
            <h1 className="text-3xl xl:text-4xl lg:text-4xl font-roundo font-bold text-black leading-tight">
              Select a plan which fits your needs
            </h1>
            <h2 className="text-lg xl:text-xl lg:text-xl font-source font-normal text-black text-opacity-80 mt-5 leading-normal">
              Flexible, Transparent Pricing Built for Every Institution —
              Empowering You to Engage, Connect, and Grow Your Alumni Network.
            </h2>
          </div>
          <div className="col-span-1 flex items-center justify-end relative mt-5 xl:mt-0 lg:mt-0">
            <div className="w-full xl:w-3/4 lg:w-3/4 bg-white rounded-2xl p-5 xl:p-10 lg:p-10 shadow-md z-20">
              <h5 className="text-lg font-source font-regular text-black text-opacity-80 leading-relaxed">
                Alumni are the lasting legacy of any great institution — their
                connections carry the spirit of the university across
                generations.
              </h5>
              <div className="mt-5">
                <h5 className="text-base font-source font-medium text-black">
                  Dr. Johnnetta B. Cole
                </h5>
                <p className="text-sm font-source font-normal text-black text-opacity-80">
                  Former president of Spelman College and Bennett College
                </p>
              </div>
            </div>
            <div className="absolute top-0 left-0 z-0 hidden xl:block lg:block">
              <svg
                class="blob-testimonial"
                width="722"
                height="695"
                viewBox="0 0 722 695"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  translate: "none",
                  rotate: "none",
                  scale: "none",
                  transform: "translate(70px, -370.31px)",
                  willChange: "auto",
                  opacity: "1",
                  visibility: "inherit",
                }}
              >
                <path
                  d="M401.606 4.46498C329.793 10.8255 258.937 20.3406 189.117 41.9216C112.73 65.5312 29.6997 96.4867 9.05244 184.404C-4.33126 241.425 -0.043148 298.693 11.6032 355.717C28.7117 439.488 51.7424 532.219 100.553 603.478C167.404 701.053 267.345 701.653 374.249 687.73C467.583 675.558 566.026 651.066 639.346 588.892C712.261 527.051 732.701 434.005 716.187 343.499C699.263 250.792 681.464 150.465 627.535 70.8154C573.32 -9.22899 487.063 -3.03786 401.597 4.51246L401.606 4.46498Z"
                  fill="#DCECF5"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default PricingBanner;
